{
  "version": 1,
  "asset_id": "3a3d9d02-baab-4662-a5df-098f8b378a4b",
  "project_id": "d4069efb-83f9-479f-9707-e712fc5f9875",
  "url": "/__l5e/assets-v1/3a3d9d02-baab-4662-a5df-098f8b378a4b/warmtepomp-800.avif",
  "r2_key": "a/v1/d4069efb-83f9-479f-9707-e712fc5f9875/3a3d9d02-baab-4662-a5df-098f8b378a4b/warmtepomp-800.avif",
  "original_filename": "warmtepomp-800.avif",
  "size": 16643,
  "content_type": "image/avif",
  "created_at": "2026-10-18T17:05:40Z"
}
